import React from 'react';
import { Link } from 'react-router-dom';
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  PinterestFilled,
  SendOutlined,
  MailOutlined,
} from '@ant-design/icons';
import { getMediaBaseUrl } from '../../api/api.service';
import './PostCard.css';

interface PostCardProps {
  id: number;
  image: string;
  title: string;
  author: string;
  date: string;
  excerpt: string;
  category?: string;
  authorImage?: string;
}

const PostCard: React.FC<PostCardProps> = ({
  id,
  image,
  title,
  author,
  date,
  excerpt,
  category = 'Lifestyle',
  authorImage,
}) => {
  const mediaBaseUrl = getMediaBaseUrl();
  const fallbackAvatar = `${mediaBaseUrl}/wp-content/uploads/2025/10/profile-1.jpg`;
  const fallbackImage = `${mediaBaseUrl}/wp-content/uploads/2025/10/placeholder.jpg`;
  
  const finalAuthorImage = authorImage || fallbackAvatar;

  if (!image) {
    console.warn(`⚠️ No image found for Post ID ${id}`);
  }

  return (
    <div className="post-card">
      {/* Image */}
      <div className="post-card-image-container">
        <Link to={`/post/${id}`}>
          <img
            src={image}
            alt={title}
            className="post-card-image"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = fallbackImage;
            }}
          />
        </Link>

        {/* Category Tag */}
        <div className="post-card-category">{category}</div>

        {/* Media Icon */}
        <div className="post-card-media-icon">🖼️</div>
      </div>

      {/* Post Info */}
      <div className="post-card-content">
        <div className="post-card-author">
          <img src={finalAuthorImage} alt={author} />
          <span>{author}</span>
          <span className="dot">•</span>
          <span className="date">{date}</span>
          <span className="comments">💬 (0)</span>
        </div>

        <h3>
          <Link to={`/post/${id}`} className="post-card-title-link">
            {title}
          </Link>
        </h3>

        <p className="post-card-excerpt">
          {excerpt.length > 160 ? excerpt.slice(0, 160) + '...' : excerpt}
        </p>

        <div className="post-card-footer">
          <div className="social-icons">
            <a href="#" className="post-card-social"><FacebookFilled /></a>
            <a href="#" className="post-card-social"><TwitterSquareFilled /></a>
            <a href="#" className="post-card-social"><LinkedinFilled /></a>
            <a href="#" className="post-card-social"><PinterestFilled /></a>
            <a href="#" className="post-card-social"><SendOutlined /></a>
            <a href="#" className="post-card-social"><MailOutlined /></a>
          </div>

          <Link to={`/post/${id}`} className="post-card-readmore">
            Continue reading <span style={{ fontSize: '12px' }}>›</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
